import { render, staticRenderFns } from "./CalendarEditor.vue?vue&type=template&id=1b6e788d&"
import script from "./CalendarEditor.vue?vue&type=script&lang=ts&"
export * from "./CalendarEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports